import { specialRouter } from './specialRouter.js'

// 导航工具函数
export const navigate = {
    // 导航到首页
    toHome() {
        specialRouter.navigateTo('home')
    },

    // 导航到详情页
    toDetail() {
        specialRouter.navigateTo('detail')
    },

    // 导航到关于页面
    toAbout(id) {
        specialRouter.navigateTo('about', { id })
    },

    // 导航到联系页面
    toContact(pageId) {
        specialRouter.navigateTo('contact', { pageId })
    },

    // 导航到页面
    toPage(pageId) {
        specialRouter.navigateTo('page', { pageId })
    },

    // 返回上一页
    back() {
        window.history.back()
    },

    // 生成特定格式的URL
    generatePageUrl(pageId) {
        return specialRouter.generateUrl('page', { pageId })
    },

    // 新增：使用 ?p= 格式的导航函数
    navigateWithP(pageName, additionalParams = {}) {
        const router = window.__VUE_ROUTER_INSTANCE__
        if (router) {
            router.push({
                path: '/',
                query: {
                    p: pageName,
                    ...additionalParams
                }
            })
        }
    },

    // 便捷方法：导航到首页（?p=index）
    toIndexPage() {
        this.navigateWithP('index')
    },

    // 便捷方法：导航到个人页面（?p=person）
    toPersonPage() {
        this.navigateWithP('person')
    },

    // 便捷方法：导航到联系页面（?p=contact）
    toContactPage() {
        this.navigateWithP('contact')
    },

    // 便捷方法：导航到会议页面（?p=conference）
    toConferencePage() {
        this.navigateWithP('conference')
    }
}

// 全局挂载到Vue实例
export default {
    install(app) {
        app.config.globalProperties.$navigate = navigate
        app.config.globalProperties.$specialRouter = specialRouter
    }
}
